export function filterUserSelectOption(input: string, option: any): boolean {
  const haystack =
    (typeof option?.label === 'string' ? option.label : '') ||
    (typeof option?.children === 'string' ? option.children : '') ||
    (typeof option?.['data-search'] === 'string'
      ? option['data-search']
      : '') ||
    (typeof option?.props?.['data-search'] === 'string'
      ? option.props['data-search']
      : '')
  return haystack.toLowerCase().includes(input.toLowerCase())
}

export function normalizeSearch(v: string): string {
  return (v ?? '').trim().toLowerCase()
}

export function toggleSelectAllInScope<T extends string | number>(
  current: T[],
  scope: T[]
): T[] {
  if (!scope.length) return current

  const scopeSet = new Set(scope.map(String))
  const currentSet = new Set(current.map(String))
  const isAllScopeSelected = scope.every((v) => currentSet.has(String(v)))

  if (isAllScopeSelected) {
    return current.filter((v) => !scopeSet.has(String(v)))
  }

  const next = [...current, ...scope]
  const dedup = new Map<string, T>()
  for (const v of next) dedup.set(String(v), v)
  return Array.from(dedup.values())
}
